import './FuelSurchargeAlerts.less';

import { Badge, Button, Popover, Space, Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

import { useExpiringSurcharges } from '../../hooks/apiHooks';
import FuelSurchargeSvg from '../icons/FuelSurchargeSvg';

const { Text } = Typography;

interface FuelSurchargeAlertsProps {
  collapsed?: boolean;
}

const FuelSurchargeAlerts: React.FC<FuelSurchargeAlertsProps> = ({
  collapsed,
}) => {
  const { critical, expiring, isLoading, soonToExpire, warning } =
    useExpiringSurcharges();

  if (!isLoading && expiring.length === 0) {
    return null;
  }

  const content = (
    <div
      style={{
        maxHeight: 320,
        maxWidth: 360,
        minWidth: 260,
        overflowY: 'auto',
        paddingRight: 16,
      }}
    >
      {expiring.length === 0 ? (
        <Text type="secondary">No expired fuel surcharges</Text>
      ) : (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          {critical.length > 0 && (
            <div>
              <Text
                strong
                style={{ color: '#cf1322', display: 'block', marginBottom: 8 }}
              >
                Expired
              </Text>
              {critical.map(({ carrier, expiredLabel }) => (
                <Link
                  key={carrier.id}
                  className="fuel-surcharge-alert-row"
                  style={{ color: 'inherit' }}
                  to={`/carrier/${carrier.id}/settings/options`}
                >
                  <Text>{carrier.name}</Text>
                  <Text style={{ color: '#cf1322' }}>{expiredLabel}</Text>
                </Link>
              ))}
            </div>
          )}
          {warning.length > 0 && (
            <div>
              <Text
                strong
                style={{ color: '#d46b08', display: 'block', marginBottom: 8 }}
              >
                Expired today or within 3 days
              </Text>
              {warning.map(({ carrier, expiredLabel }) => (
                <Link
                  key={carrier.id}
                  className="fuel-surcharge-alert-row"
                  style={{ color: 'inherit' }}
                  to={`/carrier/${carrier.id}/settings/options`}
                >
                  <Text>{carrier.name}</Text>
                  <Text style={{ color: '#d46b08' }}>{expiredLabel}</Text>
                </Link>
              ))}
            </div>
          )}
          {soonToExpire.length > 0 && (
            <div>
              <Text
                strong
                style={{ color: '#0958d9', display: 'block', marginBottom: 8 }}
              >
                Expiring soon
              </Text>
              {soonToExpire.map(({ carrier, daysSince, expiredLabel }) => (
                <Link
                  key={carrier.id}
                  className="fuel-surcharge-alert-row"
                  style={{ color: 'inherit' }}
                  to={`/carrier/${carrier.id}/settings/options`}
                >
                  <Text>{carrier.name}</Text>
                  <Text style={{ color: '#0958d9' }}>
                    in {Math.abs(daysSince)} day
                    {Math.abs(daysSince) !== 1 ? 's' : ''}
                  </Text>
                </Link>
              ))}
            </div>
          )}
        </Space>
      )}
    </div>
  );

  return (
    <div style={{ alignItems: 'center', display: 'flex', gap: 8 }}>
      <Popover
        content={content}
        placement="topRight"
        title="Fuel Surcharge Alerts"
        trigger="click"
      >
        <Badge count={expiring.length} size="small">
          <Button icon={<FuelSurchargeSvg />} size="middle" type="text" />
        </Badge>
      </Popover>
      {!collapsed && (
        <Typography.Text style={{ fontSize: 12 }} type="secondary">
          Fuel Surcharge Alerts
        </Typography.Text>
      )}
    </div>
  );
};

export default FuelSurchargeAlerts;
